import _keyBy from 'lodash/keyBy'
import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import template from './league-results.jade'
import {Season, Match, TablePosition} from '../../models'
import { computeLeagueResults } from '../../services/league-results'
import query from '../../services/query'

import '@scoutgg/ftw/source/atoms/form-control/form-control'
import '@scoutgg/ftw/source/atoms/button/button'
import '../seasons'

function compareRows(a, b) {
}

@Component('sporty')
@Template(template)
@Attribute('season', Season)
export default class LeagueResults extends HTMLElement {
  attached() {
    this.reload()
  }
  changeSeason({season}) {
    query({season})
  }
  seasonChange() {
    this.reload()
  }
  async reload() {
    if(!this.season) return
    const params = {
      $reload: true,
      season: this.season._id,
    }
    const data = await Match.load(params)
    const teamTable = this.buildTable(data)
    this.season.tablePositions = teamTable
    await this.applyState({
      realMatches: data.matches,
      teams: data.teams,
    })
  }
  buildTable({matches, teams}) {
    const sport = this.season && this.season.sport
    if(!sport) return
    const results = computeLeagueResults({ matches, teams })
    const teamMap = _keyBy(teams, '_id')
    const originalMap = _keyBy(this.season.tablePositions, 'teamId')
    return (results.pop() || []).map(row => {
      const team = teamMap[row.team]
      row = {
        ...row,
        original: originalMap[row.team],
      }
      if(row.original?.strength != null) {
        row.strength = row.original.strength
      } else {
        row.strength = row.points
      }
      delete row.diff // Getter property in table position model
      return row
    })
  }

  isDifferent(a, b) {
    if(!b) return true
    if(a.rank !== b.rank) { return true }
    if(a.points !== b.points) { return true }
    if(a.goals !== b.goals) { return true }
    if(a.against !== b.against) { return true }
  }

  diffClass(diff) {
    return diff < 0 ? 'negative' : diff ? 'positive' : 'zero'
  }

  async save() {
    await this.season.save({
      updatedProperties: ['tablePositions'],
    })
    await this.reload()
  }
}
